import React from 'react';
import * as pt from 'prop-types';
import createReactClass from 'create-react-class';
import _ from 'underscore'
import moment from 'moment';
import xtend from 'xtend';
import Switch from 'react-bootstrap-switch';
import DatePicker from 'react-datepicker';
import ReactQuill from 'react-quill';
import IconButton from '@material-ui/core/IconButton';
import PlaylistAdd from '@material-ui/icons/PlaylistAdd';
import InfoIcon from '@material-ui/icons/Info';

import SentryReporter from '../../../../utils/SentryReporter'
import ClockPicker from '../../../../common/components/inputs/ClockPicker';
import withValidator from '../../../../hocs/Validator'
import RestrictionsModal from './general/RestrictionsModal'
import AiCaptions from './general/AiCaptions'
import HtmlAnchorReplacer from '../../../../utils/HtmlAnchorReplacer';
import Badge from '@material-ui/core/Badge';
import RestrictedComponent from '../../../../lib/components/form/RestrictedComponent';
import schema from '../../../../routes/permissions/schema';
import LargeToolTip from '../../../../account/components/LargeToolTip';

const TIME_FMT = 'HH:mm:ss';
const DATE_FMT = 'YYYY-MM-DD';
const FULL_DT_FMT = DATE_FMT + ' ' + TIME_FMT;

function getInitialComponentState (props) {
    return {
        validators: [],
        edited: false,
        edits: {
            description: props.event.description
        },
        restrictionsModal: false,
    };
}

var General = createReactClass({
    propTypes: {
        event: pt.object.isRequired,
        actions: pt.shape({
            edit: pt.func.isRequired
        }).isRequired
    },

    getInitialState: function () {
        return getInitialComponentState(this.props);
    },

    shouldComponentUpdate: function (nextProps, nextState) {
        return this.props !== nextProps || this.state !== nextState;
    },

    handleChange: function (ev) {
        let value;
        const { name, type } = ev.target;

        switch (type) {
            case 'checkbox':
                value = ev.target.checked;
                break;

            default:
                value = ev.target.value;
        }
        let updates = {};

        switch (name) {
            case 'streamtext':
                updates.liveCaptions = {
                    vendorID: 1,
                    captionID: value
                };
                break;

            case 'startTime':
                updates[name] = value.format('HH:mm:ss');
                break;

            default:
                updates[name] = value;
        }

        var edits;
        if (!this.state.edited) {
            let event = this.props.event

            let date, time

            date = moment.isMoment(event.startDateTime) ?
                event.startDateTime.format(DATE_FMT) :
                moment(event.startDateTime.split(' ')[0], DATE_FMT);

            time = moment.isMoment(event.startDateTime) ?
                event.startDateTime.format(TIME_FMT) :
                moment(event.startDateTime.split(' ')[1], TIME_FMT);

            edits = {
                title: event.title,
                private: event.private,
                startDate: date,
                startTime: time,
                eventStatus: event.eventStatus,
                estRuntime: event.estRuntime,
                liveAiCaptions: event.liveAiCaptions,
                description: event.description,
                notes: event.notes,
                liveCaptions: event.liveCaptions || {
                    vendorID: 1,
                    captionID: null
                }
            };
        } else {
            edits = this.state.edits;
        }

        this.setState({
            edited: true,
            edits: xtend(edits, updates)
        });
    },

    handlePrivateChange: function (el, value) {
        this.handleChange({
            target: {
                name: 'private',
                type: 'checkbox',
                checked: value
            }
        });
    },
    handleAiCaptioningChange: function(el, value) {
        this.handleChange({
            target: {
                name: 'liveAiCaptions',
                type: 'checkbox',
                checked: value
            }
        })
        // instantly save changes to AI captioning
        this.save({liveAiCaptions: value})
    },

    handleDateChange: function (value) {
        if (value !== null) {
            this.handleChange({
                target: {
                    name: 'startDate',
                    type: 'text',
                    value: value
                }
            });
        }
    },

    handleDescriptionChange: function (value,v,c) {
        if (!this.state.edited) {
            // https://github.com/quilljs/quill/issues/1134#issuecomment-265065953
            var self = this;
            _.defer(function () {
                self.handleChange({
                    target: {
                        name: 'description',
                        type: 'text',
                        value: value
                    }
                });
            });
        } else {
            this.handleChange({
                target: {
                    name: 'description',
                    type: 'text',
                    value: value
                }
            });
        }
    },

    handleTimeChage: function (value) {
        this.handleChange({target: {
            name: 'startTime',
            value: value
        }});
    },

    save: function (inProgressEdits) {
        const { edits } = this.state;

        let event = this.props.event

        let stateMembers = xtend(
            _.pick(event,
                'title',
                'startDateTime',
                'description',
                'notes',
                'private',
                'estRuntime',
                'liveCaptions',
                'liveAiCaptions'
            ),
            edits,
            inProgressEdits
        )
        
        let isValid = this.props.validate('event', stateMembers)

        if (!isValid) {
            this.setState({
                validators: isValid
            })
        } else {
            var hasDescription = (
                edits.description !== undefined &&
                edits.description !== '<div><br></div>' &&
                edits.description !== '<div>&nbsp;</div>' &&
                edits.description !== 'null' &&
                edits.description !== null &&
                edits.description !== '<p><br></p>' &&
                edits.description !== '<h1><br></h1>' &&
                edits.description !== '<h2><br></h2>' &&
                edits.description !== '<blockquote><br></blockquote>'
            );

            if (hasDescription) {
                edits.description =
                    HtmlAnchorReplacer.parseAndRepaceAnchors(
                        edits.description
                    )
            }

            var time = moment.isMoment(edits.startTime) ?
                edits.startTime.format(TIME_FMT) :
                edits.startTime;
            const payload = {
                title: edits.title ? edits.title : stateMembers.title,
                eventNotes: edits.notes ? edits.notes : stateMembers.notes,
                private: edits.private !== undefined ? edits.private : stateMembers.private,

                startDateTime: edits.startDate ? (edits.startDate.format('YYYY-MM-DD') +
                    ' ' + time) : stateMembers.startDateTime,
                estRuntime: edits.estRuntime ? (moment.duration(edits.estRuntime).asMinutes()) : stateMembers.estRuntime
            };
            if (hasDescription) {
                payload.description = edits.description
            } else {
                payload.description = null; // only way to clear description in the backend
            }

            var _captionsOk = (
                edits.liveCaptions &&
                !!edits.liveCaptions.captionID === true
            );

            if (_captionsOk) {
                payload.liveCaptions = edits.liveCaptions;
            } else{
                // Reset it
                payload.liveCaptions = null;
            }
            // liveAiCaptions edits take precedence and are true/false
            if (inProgressEdits.liveAiCaptions === true || inProgressEdits.liveAiCaptions === false) {
                payload.liveAiCaptions = inProgressEdits.liveAiCaptions
            } else if (edits.liveAiCaptions === true || edits.liveAiCaptions === false) {
                payload.liveAiCaptions = edits.liveAiCaptions
            } else {
                payload.liveAiCaptions = event.liveAiCaptions.isEnabled
            }

            this.props.actions.edit(payload);
        }
    },

    toggleRestrictiongsModal: function (ev) {
        ev && ev.preventDefault()
        this.setState({
            restrictionsModal: !this.state.restrictionsModal
        })
    },

    deleteAllRestrictions: function (ev) {
        ev && ev.preventDefault()
        const payload = {
            eventID:this.props.event.eventID,
            clientID: this.props.event.clientID
        }
        this.props.actions.restrictedDomains.delete(payload)
    },

    revert: function () {
        this.setState(getInitialComponentState(this.props));
    },

    hasRestrictions: function () {
        let event = this.props.event
        const icon = <RestrictedComponent
            label="You do not have the permissions to change these"
            permissionCheck={schema.EVENT_TAB_GENERAL.DOMAIN_RESTRICTIONS}
        >
            <IconButton
                onClick={this.toggleRestrictiongsModal}
                color="primary"
                aria-label="Edit Domain Restrictions"
                component="span">
                <PlaylistAdd fontSize="large"/>
            </IconButton>
        </RestrictedComponent>

        if (!!event.restrictedDomains){
            if (event.restrictedDomains.length > 0) {
                return (
                    <Badge badgeContent={event.restrictedDomains.length} color="primary">
                        {icon}
                    </Badge>
                )
            }
        }
        return icon
    },

    render: function () {
        let event = this.state.edited ?
            this.state.edits :
            this.props.event

        event.estRuntime = this.state.edited ? 
            this.state.edits.estRuntime : 
            moment.utc(moment.duration(event.estRuntime, 'minutes').asMilliseconds()).format('HH:mm')

        let date, time

        try {
            if (this.state.edited) {
                date = event.startDate
                time = event.startTime
            } else if (moment.isMoment(event.startDateTime)) {
                date = event.startDateTime.format(DATE_FMT)
                time = event.startDateTime.format(TIME_FMT)
            } else {
                date = event.startDateTime.split(' ')[0]
                time = event.startDateTime.split(' ')[1]
            }
        } catch (error) {
            console.warn(error)
            SentryReporter.send(
                'General Tab: Time Formatting Issue', 'error', {
                    error: error,
                    event: event,
                    state: this.state
                }
            )
        }

        date = moment(date, DATE_FMT);
        var clientTZ = moment.tz(this.props.timeZone)
        var clientTZabbr = clientTZ.format("z");
        var offset = clientTZ.utcOffset() / 60;


        return (
            <div className="tab-general">
                <RestrictedComponent permissionCheck={schema.EVENT_TAB_GENERAL.UPDATE}>
                    <div className="callout clearfix">
                        <div className="row">
                            <div className="col-sm-8">
                                <div className={'validation-wrapper ' + ((this.state.validators.indexOf('title') !== -1) ? 'invalid' : 'valid')}>
                                    <label>Event Title</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="title"
                                        placeholder="Cannot be empty"
                                        value={event.title || ''}
                                        onChange={this.handleChange}
                                    />
                                </div>
                            </div>
                            <div className="col-sm-2">
                                <label>Private</label>
                                <div style={{display: 'block'}}>
                                    <Switch
                                        onChange={this.handlePrivateChange}
                                        value={event.private}
                                        animate={false} />
                                </div>
                            </div>
                            <div className="col-sm-2">
                                <label>Viewing Restrictions</label>
                                <div style={{display: 'block'}}>
                                By Domains:{this.hasRestrictions()}
                                </div>

                                <RestrictionsModal
                                    clientID={this.props.clientID}
                                    event={this.props.event}
                                    actions={this.props.actions}
                                    visible={this.state.restrictionsModal}
                                    toggleModal={this.toggleRestrictiongsModal}
                                    deleteAll={this.deleteAllRestrictions}
                                />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-sm-2">
                                <label>Start Date</label>
                                <div className={'validation-wrapper ' + ((this.state.validators.indexOf('startDate') !== -1) ? 'invalid' : 'valid')}>
                                    <div className="input-group">
                                        <span className="input-group-addon"><i className="fa fa-calendar"/></span>
                                        <DatePicker
                                            className="form-control"
                                            dateFormat="MM/DD/YYYY"
                                            selected={date}
                                            onChange={this.handleDateChange}/>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-4">
                                <div className={'validation-wrapper ' + ((this.state.validators.indexOf('startTime') !== -1) ? 'invalid' : 'valid')}>

                                    <label>Start Time </label>
                                    <span className='tz-notate'>{' ('+clientTZabbr+', UTC '+offset+')'} </span>
                                    <div className="input-group">
                                        <span className="input-group-addon"><i className="far fa-clock"/></span>
                                        <ClockPicker
                                            name="startTime"
                                            value={time}
                                            id={this.props.event.eventID + '-startTime-input'}
                                            handleChange={this.handleTimeChage}/>
                                    </div>

                                </div>
                            </div>
                            <div className="col-sm-4">
                                <div className={'validation-wrapper ' + ((this.state.validators.indexOf('estRuntime') !== -1) ? 'invalid' : 'valid')}>
                                    <label>Estimated Runtime</label>

                                    <div className="input-group">
                                        <span className="input-group-addon"><i className="far fa-clock"/></span>
                                    
                                        <input 
                                        type="text" 
                                        placeholder="hh:mm" 
                                        className="form-control"
                                        maxLength={5} 
                                        name="estRuntime"
                                        onChange={(e) => {
                                            const validationWrapperClassList = e.target.closest(".validation-wrapper").classList;
                                            const value = e.target.value;
                                            const numOnlyRegex = /[^0-9]/g;

                                            let customValue = value;
                                            
                                            validationWrapperClassList.remove("valid")
                                            validationWrapperClassList.add("invalid")

                                            if (value.includes(":")) {
                                                if(value.lastIndexOf(":") != 2) {
                                                    return
                                                }
                                            }
                                            
                                            if (value.length == 2) {
                                                customValue += ":";
                                            }

                                            let inputArray = customValue.split(':');

                                            if (Number(inputArray[0]) > 24) {
                                                inputArray[0] = "24";
                                            } else if (inputArray[0] && inputArray[0].match(numOnlyRegex)) return;

                                            if (Number(inputArray[1]) > 59) {
                                                inputArray[1] = "59";
                                            } else if (inputArray[1] && inputArray[1].match(numOnlyRegex)) return;

                                            if (Number(inputArray[0]) == 24 && inputArray[1]) {
                                                inputArray[1] = "00";   
                                            }

                                            if (inputArray[0] === "00" && inputArray[1] === "00") {
                                                inputArray[0] = "01";
                                                inputArray[1] = "00";
                                            }

                                            const HAMString = inputArray.join(':');
                                            if (HAMString.length == 5) {
                                                validationWrapperClassList.remove("invalid")
                                                validationWrapperClassList.add("valid")
                                            }    
                                            
                                            this.handleChange({
                                                target: {
                                                    name: "estRuntime",
                                                    value: HAMString,
                                                },
                                            });
                                                                            
                                        }} 

                                        onKeyDown={(e) => {
                                        if (e.key == 'Backspace') {
                                            const validationWrapperClassList = e.target.closest(".validation-wrapper").classList;

                                            if(e.target.value.length == 1) {
                                                validationWrapperClassList.remove("invalid")
                                                validationWrapperClassList.add("valid")
                                            }

                                            this.handleChange({
                                                target: {
                                                    name: "estRuntime",
                                                    value: e.target.value.slice(0, -1),
                                                },
                                            });
                                        }
                                        }}

                                        onBlur={(e) => {
                                            if (e.target.value.length === 5) return;
        
                                            let editedValue = e.target.value;
                                            const validationWrapperClassList = e.target.closest(".validation-wrapper").classList;
                                            
                                            switch (editedValue.length) {
                                                case 0:
                                                    editedValue = "01:00"
                                                    break;
                                                case 1:
                                                    editedValue = "0" + editedValue + ":00"
                                                    break;
                                                case 3:
                                                    editedValue += "00"
                                                    break;
                                                case 4:
                                                    editedValue += "0"
                                                    break;
                                                default:
                                                    break;
                                            }
        
                                            if(editedValue === "00:00") {
                                                editedValue = "01:00"
                                            }
        
                                            validationWrapperClassList.remove("invalid")
                                            validationWrapperClassList.add("valid")
        
                                            this.handleChange({
                                                target: {
                                                    name: "estRuntime",
                                                    value: editedValue,
                                                },
                                            });
                                        }}

                                        value={event.estRuntime}
                                         />
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div className="row">
                            <div className="col-sm-2">
                                <div>
                                    <label>AI Captioning </label>
                                    <LargeToolTip
                                        title={`AI captions cannot be enabled or disabled during a live event, and must be enabled when an event goes live to be generated`}
                                    >
                                        <InfoIcon style={{color:'#5252c6',fontSize:20,marginBottom:'-5px',marginLeft:'5px'}}/>
                                    </LargeToolTip>
                                </div>
                                <AiCaptions event={event} onChange={this.handleAiCaptioningChange} />
                            </div>
                            <div className="col-sm-4">
                                <div className={'validation-wrapper ' + ((this.state.validators.indexOf('streamtext') !== -1) ? 'invalid' : 'valid')}>
                                    <label>StreamText Captioning</label>
                                    <div className="input-group">
                                        <span className="input-group-addon"><i className="far fa-closed-captioning"/></span>
                                        <input
                                            className="form-control"
                                            name="streamtext"
                                            placeholder="Your StreamText ID"
                                            value={(
                                                event.liveCaptions &&
                                                event.liveCaptions.captionID
                                            ) ? event.liveCaptions.captionID : ""
                                            }
                                            onChange={this.handleChange}/>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-7"></div>
                        </div>
                        
                        <div className="row">
                            <div className="col-sm-6">
                                <label>Description</label>

                                <ReactQuill
                                    modules={this.modules}
                                    formats={this.formats}
                                    value={this.getEditorContents()}
                                    onChange={this.handleDescriptionChange}>
                                </ReactQuill>
                            </div>

                            <div className="col-sm-6">
                                <label>Notes</label>
                                <textarea
                                    className="form-control"
                                    name="notes"
                                    value={event.notes ? event.notes : ""}
                                    onChange={this.handleChange}/>
                            </div>
                        </div>
                    </div>

                </RestrictedComponent>
                <div className="tab-actions">
                    <button className="btn btn-default" disabled={!this.state.edited} onClick={this.revert}><i className="fa fa-undo"/> Revert Changes</button>
                    <RestrictedComponent permissionCheck={schema.EVENT_TAB_GENERAL.UPDATE}>
                        <button className="btn btn-success" disabled={!this.state.edited} onClick={this.save}><i className="fa fa-save"/> Save Changes</button>
                    </RestrictedComponent>
                </div>
            </div>
        );
    },

    getEditorContents: function () {
        const description = this.state.edited ?
            this.state.edits.description :
            this.props.event.description
        if (description === 'null') {
            return ''
        } else {
            return description
        }
    },

    modules: {
        toolbar: [
            [{ 'header': [1, 2, false] }],
            ['bold', 'italic', 'underline', 'blockquote'],
            [{'list': 'ordered'}, {'list': 'bullet'}, {'indent': '-1'}, {'indent': '+1'}],
            ['link'],
            ['clean']
        ]
    },

    formats: [
        'header',
        'bold', 'italic', 'underline', 'strike', 'blockquote',
        'list', 'bullet', 'indent',
        'link'
    ]
});

export default withValidator(General);
